import { Article, ArticleGroup } from '../types';

class ArticlesRepository extends ArticleRepository<ArticleGroup> {
  override getMany() {
    return this._getMany({ url: '/home', cache: 'always' });
  }

  getHomepageArticles(limit = 4) {
    return this._getMany({
      url: '/articles',
      cache: 'always',
      query: { limit, isHomepage: true },
    });
  }
}

class HomepageArticlesRepository extends ArticleRepository<Article> {
  override getMany(limit = 4) {
    return this._getMany({
      url: '/articles',
      cache: 'always',
      query: { limit, isHomepage: true },
    });
  }
}

export const articlesRepository = new ArticlesRepository();
export const homepageArticlesRepository = new HomepageArticlesRepository();
